import styled from "@emotion/styled";
import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const BodyHeader = styled.div`
  padding: 12px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const InputStyle = styled.input`
  width: 100%;
  height: 30px;
  padding: 8px 8px 8px 35px;
  font-size: 13px;
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  &:focus {
    outline: none;
    border-color: #ccc;
  }
  ,
  &::placeholder {
    color: #afafaf;
  }
`;

const BodyContainer = styled.div`
  margin-top: 50px;
  border-bottom: 1px solid ${theme.colors.bordertask};
  display: flex;
  padding: 0px 20px 0px 20px;
  justify-content: space-between;
  align-items: center;
`;

const Container = styled.div``;

const HeadingTag = styled.p`
  float: left;
  margin: 5px;
  padding: 0px 20px 0px 0px;
  font-weight: bold;
`;
const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 10px;
  color: #afafaf;
  font-size: 20px;
`;
const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 500px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 5px;
`;

const HeaderStyle = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #333333;
`;

const CountStyle = styled.span`
  font-size: 12px;
  font-weight: bold;
  color: ${theme.colors.themeColor};
  margin-bottom: 10px;
`;

const TabDiv = styled.div`
  display: flex;
  gap: 20px;
  padding: 0px 8px;
  margin: 0px 20px 0px 20px;
  align-items: baseline;
`;

const PopoverContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PopoverSpan = styled.span`
  background-color: #f3f3f3;
`;

const MoreVertIcon = styled(InnoIcons.MoreVertIcon)`
  font-size: 15px;
  cursor: pointer;
  margin: 5px 0px 5px 0px;
  background-color: #f3f3f3;
`;

const ParagaphStyle = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  opacity: 0.7;
  margin-block: 0px;
  padding-block: 0px;
  height: 15px;
`;
const Table = styled.table`
  width: 200px;
`;
const Thead = styled.thead``;
const Tbody = styled.tbody``;

const TR = styled.tr``;

const Th = styled.th`
  color: ${theme.colors.themeColor};
  border-bottom: 1px solid ${theme.colors.bordertask};
  text-align: left;
`;
const Tr = styled.tr`
  margin-bottom: 20px;
`;

const Td = styled.td`
  border-bottom: 1px solid ${theme.colors.bordertask};
`;

const RICContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 25px 0px 0px;
  gap: 20px;
  justify-content: end;
  width: 100%;
`;

const Paragraph = styled.p`
  font-size: 14px;
  display: flex;
  align-items: center;
`;

const Rspan = styled.span`
  width: 15px;
  height: 15px;
  background-color: red;
  border-radius: 50%;
  margin-right: 8px;
`;
const Ispan = styled.span`
  width: 15px;
  height: 15px;
  background-color: #fd6c1c;
  border-radius: 50%;
  margin-right: 8px;
`;
const Cspan = styled.span`
  width: 15px;
  height: 15px;
  background-color: #676668;
  border-radius: 50%;
  margin-right: 8px;
`;

const SC = {
  Container,
  BodyHeader,
  BodyContainer,
  HeadingTag,
  InputStyle,
  SearchIcon,
  InputContiner,
  HeaderContainer,
  HeaderStyle,
  CountStyle,
  SearchIcon,
  InputStyle,
  TabDiv,
  PopoverContainer,
  PopoverSpan,
  MoreVertIcon,
  ParagaphStyle,
  Table,
  Thead,
  Tbody,
  TR,
  Th,
  Tr,
  Td,
  RICContainer,
  Paragraph,
  Rspan,
  Ispan,
  Cspan,
};

export default SC;
